import React from 'react';
import { cn } from '../../../../utils/styles';

interface CardProps extends React.PropsWithChildren, React.HTMLAttributes<HTMLDivElement> {
  label?: React.ReactNode;
  extra?: React.ReactNode;
  headingContent?: React.ReactNode;
}

function WrapperCard({ label, extra, headingContent, children, className, ...rest }: CardProps) {
  return (
    <div className={cn(['mb-5 shadow-md rounded-lg text-primary'], className)} {...rest}>
      <div className={cn(['card-heading', 'bg-slate-200 rounded-t-lg', 'px-5 py-2.5'])}>
        <div className="w-full flex justify-between items-center">
          <div className="text-lg font-bold text-primary">{label}</div>

          <div>{extra}</div>
        </div>
        {headingContent ? <div className="text-sm text-primary-80">{headingContent}</div> : null}
      </div>
      {children}
    </div>
  );
}

WrapperCard.defaultProps = {
  label: undefined,
  extra: undefined,
  headingContent: undefined,
};

export default WrapperCard;
